import { render, staticRenderFns } from "./BreederDashboardDetail.vue?vue&type=template&id=70a54146&"
import script from "./BreederDashboardDetail.vue?vue&type=script&lang=js&"
export * from "./BreederDashboardDetail.vue?vue&type=script&lang=js&"
import style0 from "./BreederDashboardDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports